var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("header", { staticClass: "header" }, [
        _c("div", { staticClass: "leftBox" }, [
          _c("p", { staticClass: "p1" }, [_vm._v("机构账户认证信息")]),
          _vm._m(0),
          _vm._m(1),
          _c("p", { staticClass: "p2" }, [
            _c("span", { staticClass: "span1" }, [_vm._v("机构名称：无")]),
            _c(
              "span",
              {
                staticClass: "span2",
                on: { click: _vm.handlerModifyPasswordClick },
              },
              [_vm._v("修改密码")]
            ),
          ]),
          _c("p", { staticClass: "p2" }, [
            _c("span", { staticClass: "span1" }, [
              _vm._v("绑定手机：13910581028"),
            ]),
            _c(
              "span",
              {
                staticClass: "span2",
                on: { click: _vm.handlerModifyApplyClick },
              },
              [_vm._v("改绑申请")]
            ),
          ]),
          _vm._m(2),
          _vm._m(3),
        ]),
        _vm._m(4),
      ]),
      _c("footer", { staticClass: "footer" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "lineBox" },
            [
              _c("div", { staticClass: "line1" }, [
                _c("img", {
                  staticStyle: { "margin-right": "0.1rem" },
                  attrs: { src: require("@/assets/png/img.png") },
                }),
                _vm._m(5),
              ]),
              _c(
                "el-button",
                { staticClass: "btns", attrs: { size: "small", plain: "" } },
                [_vm._v("升级")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "lineBox" },
            [
              _vm._m(6),
              _c(
                "el-button",
                { staticClass: "btns", attrs: { size: "small", plain: "" } },
                [_vm._v("延期")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "lineBox",
              staticStyle: { "margin-bottom": "0.2rem" },
            },
            [
              _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      "margin-bottom": "0.1rem",
                    },
                  },
                  [
                    _vm._m(7),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("p", { staticClass: "p3 p4" }, [
                          _vm._v("钱包余额："),
                        ]),
                        _c("p", { staticClass: "p3" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.balanceObj.balance +
                                  _vm.balanceObj.lockBalance
                              )
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._m(8),
              ]),
              _c(
                "el-button",
                { staticClass: "btns", attrs: { size: "small", plain: "" } },
                [_vm._v("充值")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c(
                "el-button",
                { staticClass: "btns1", attrs: { type: "primary" } },
                [
                  _vm._v("推荐地接360给同业好友 可得20元优惠券"),
                  _c("i", {
                    staticClass: "el-icon-arrow-right el-icon--right",
                  }),
                ]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "right" },
          _vm._l(_vm.blockList, function (item, index) {
            return _c("div", { key: index, staticClass: "rightblock" }, [
              _c("p", { staticClass: "p1" }, [
                _vm._v(" " + _vm._s(item.num)),
                _c("span", [_vm._v(_vm._s(item.dan))]),
              ]),
              _c("p", { staticClass: "p2" }, [_vm._v(_vm._s(item.title))]),
            ])
          }),
          0
        ),
      ]),
      _c("modifyPasswordPopup", { ref: "modifyPasswordPopup" }),
      _c("reorganizationPopup", { ref: "rechargePopup" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p2" }, [
      _c("span", { staticClass: "span1" }, [
        _vm._v("认证身份：机构用户（旅行社）"),
      ]),
      _c("span", { staticClass: "span2" }, [_vm._v("权限查看")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "align-items": "center",
          "justify-content": "space-between",
          "margin-bottom": "0.12rem",
        },
      },
      [
        _c("p", { staticClass: "p3" }, [
          _vm._v("资质信息："),
          _c("span", [_vm._v("待认证")]),
        ]),
        _c("p", { staticClass: "p4" }, [
          _vm._v("资质信息："),
          _c("span", [_vm._v("待认证")]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p2" }, [
      _c("span", { staticClass: "span1" }, [_vm._v("法定代表：无")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "p2" }, [
      _c("span", { staticClass: "span1" }, [_vm._v("员工账号：无")]),
      _c("span", { staticClass: "span2" }, [_vm._v("维护员工账号")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rightBox" }, [
      _c("div", { staticStyle: { width: "45%" } }, [
        _c("p", { staticClass: "p1" }, [_vm._v("平台认证")]),
        _c("p", { staticClass: "p2" }, [
          _c(
            "span",
            { staticClass: "span1", staticStyle: { "font-weight": "bold" } },
            [_vm._v("定制师中心：未上线")]
          ),
          _c("span", { staticClass: "span2" }, [_vm._v("设置")]),
        ]),
        _c("p", { staticClass: "p2" }, [
          _c("span", { staticClass: "span1" }, [
            _vm._v("认证身份：平台普通用户"),
          ]),
        ]),
        _c("p", { staticClass: "p2" }, [
          _c("span", { staticClass: "span1" }, [_vm._v("机构名称：无")]),
          _c("span", { staticClass: "span2" }, [_vm._v("查看")]),
        ]),
        _c("p", { staticClass: "p2" }, [
          _c("span", { staticClass: "span1" }, [_vm._v("认证有效期：无")]),
          _c("span", { staticClass: "span2" }, [_vm._v("查看")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "p1" }, [
        _vm._v("门店 "),
        _c("span", [_vm._v("LV1")]),
      ]),
      _c("p", { staticClass: "p2" }, [_vm._v("当前等级已享9项基本权益")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("p", { staticClass: "p3 p4" }, [_vm._v("有效期：")]),
        _c("p", { staticClass: "p3" }, [_vm._v("一直有效")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "align-items": "center",
          "margin-right": "0.24rem",
        },
      },
      [
        _c("p", { staticClass: "p3 p4" }, [_vm._v("累计充值：")]),
        _c("p", { staticClass: "p3" }, [_vm._v("￥0")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("p", { staticClass: "p3 p4" }, [_vm._v("员工人数：")]),
        _c("p", { staticClass: "p3" }, [_vm._v("6人")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }